import { Location } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { CurriculumService } from 'app/main/services/curriculum.service';
import { DisputesService } from 'app/main/services/disputes.service';
import { UtilsService } from 'app/main/services/utils.service';
import { LoaderService } from '../../services/loaderService.service';
import { LocalAccountService } from '../../services/localAccount.service';
import { VariationProposalComponent } from '../variation-proposal/variation-proposal.component';
import { VievProfessorCurriculumComponent } from '../view-professor-curriculum/view-professor-curriculum.component';
import { ViewAvailabilitiesComponent } from './view-availabilities/view-availabilities.component';

@Component({
  selector: 'app-select-professor',
  templateUrl: './select-professor.component.html',
  styleUrls: ['./select-professor.component.scss']
})
export class SelectProfessorComponent implements OnInit {

  @Input() professorsList: any[];
  @Input() studentAvailabilities: any;
  @Input() color: string;
  @Input() studentBestMatchRequestId: string;
  variationDialog: any;
  @Input() subscriptionName: string;
  @Input() subscriptionId: string;
  @Input() subscriptionTypeToShow: string;
  isModal: boolean;
  rgbColor: any;
  isDarkBackground: boolean;

  disputeId: string;

  @Output() emitData: EventEmitter<any> = new EventEmitter();
  // private templateRef: MatDialogRef<TemplateRef<any>>;

  selectedData: any;
  richiedente: any;
  isChangeProfessorProposal: boolean;


  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) data,
    @Optional() private dialogRef: MatDialogRef<SelectProfessorComponent>,
    private dialog: MatDialog,
    private location: Location,
    private loaderService: LoaderService,
    private utilsService: UtilsService,
    private curriculumService: CurriculumService,
    private localAccountService: LocalAccountService,
    private disputeService: DisputesService,
    private router: Router
  ) {

    if (data) {
      this.isModal = true;
      this.professorsList = data.obj;
      this.subscriptionId = data.subscriptionId;
      this.subscriptionName = data.subscriptionName;
      this.subscriptionTypeToShow = data.subscriptionTypeToShow;
      if (data.color) {
        this.color = data.color;
      } else {
        this.color = '#3c4252';
      }
      if (data.isChangeProfessorProposal) {
        this.isChangeProfessorProposal = true;
        this.disputeId = data.disputeId;
        if (data.studentBestMatchRequestId) {
          this.studentBestMatchRequestId = data.studentBestMatchRequestId;
        }
      }
    } else {
      this.isModal = false;
    }
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['subscriptionTypeToShow']) {
      if (changes['subscriptionTypeToShow'].currentValue) {
        this.subscriptionTypeToShow = changes['subscriptionTypeToShow'].currentValue;
      }
    }
    if (changes['subscriptionName']) {
      if (changes['subscriptionName'].currentValue) {
        this.subscriptionName = changes['subscriptionName'].currentValue;
      }
    }
    if (changes['subscriptionId']) {
      if (changes['subscriptionId'].currentValue) {
        this.subscriptionId = changes['subscriptionId'].currentValue;
      }
    }
    if (changes['professorsList']) {
      if (changes['professorsList'].currentValue) {
        this.professorsList = changes['professorsList'].currentValue;
      }
    }
    if (changes['studentAvailabilities']) {
      if (changes['studentAvailabilities'].currentValue) {
        this.studentAvailabilities = changes['studentAvailabilities'].currentValue;
      }
    }
    if (changes['studentBestMatchRequestId']) {
      if (changes['studentBestMatchRequestId'].currentValue) {
        this.studentBestMatchRequestId = changes['studentBestMatchRequestId'].currentValue;
      }
    }
    if (changes['color']) {
      if (changes['color'].currentValue) {
        this.color = changes['color'].currentValue;
        if (!this.color) {
          this.color = '#3c4252';
        }
        this.rgbColor = this.setRGB(this.color);
        this.isDarkBackground = this.isDark();
      }
    }
  }

  isDark() {
    if (this.rgbColor) {
      const color = Math.round(
        ((this.rgbColor.r * 299) +
          (this.rgbColor.g * 587) +
          (this.rgbColor.b * 114)) / 1000);
      return (color < 125) ? true : false;
    }
  }

  setRGB(color) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  async ngOnInit() {
    await this.localAccountService.getAccount().then((res: any) => {
      this.richiedente = res;
    });
  }

  goBack() {
    this.location.back(); // nel caso in cui dovesse arrivare alla pagina per vie traverse riceverebbe sempre un 404
  }

  availabilitiesToString(availability) {
    let avToString = '';
    if (availability.availabilities && availability.availabilities.length > 0) {
      for (let i = 0; i < availability.availabilities.length; i++) {
        const currAv = availability.availabilities[i];
        avToString += currAv.dayOfWeek;
        for (let j = 0; j < currAv.hours.length; j++) {
          const currHours = currAv.hours[j];
          const startEnd = currHours.startHour + currHours.endHour;
          avToString += startEnd;
        }
      }
    }
    if (availability.singularAvailabilities && availability.singularAvailabilities.length > 0) {
      for (let i = 0; i < availability.singularAvailabilities.length; i++) {
        const currAv = availability.singularAvailabilities[i];
        avToString += currAv.dayOfWeek + currAv.date;
        for (let j = 0; j < currAv.hours.length; j++) {
          const currHours = currAv.hours[j];
          const startEnd = currHours.startHour + currHours.endHour;
          avToString += startEnd;
        }
      }
    }
    return avToString;
  }

  async openCalendarDialog(opt) {
    let hideVariationProposalButton = false;
    let isMonteOre = false;
    if (!this.isChangeProfessorProposal) {
      if (this.studentAvailabilities.availabilities.length > 0) {
        isMonteOre = false;
        const studentAvailabilitiesToString = this.availabilitiesToString(this.studentAvailabilities);
        const professorAvailabilitiesToString = this.availabilitiesToString(opt.availability);
        if (studentAvailabilitiesToString === professorAvailabilitiesToString) {
          hideVariationProposalButton = true;
        }
      } else {
        isMonteOre = true;
        hideVariationProposalButton = true;
      }
    }
    let buttons = null;
    if (this.isChangeProfessorProposal) {
      buttons = [
        {
          text: 'Proponi Formatore',
          color: 'default',
          close: true,
          value: true,
          disabled: false,
          callback: async (value) => {
            this.loaderService.showLoader();
            const obj: any = {
              professorId: opt.professorId,
              studentBestMatchId: this.studentBestMatchRequestId,
              id: this.disputeId
            };
            const resp: any = await this.disputeService.newProposalChangeProfessor(obj).catch((err) => {
              console.error(err);
              this.loaderService.hideLoader();
            });
            if (resp) {
              if (resp.ok) {
                this.dialogRef.close();
                this.router.navigateByUrl('administration-area/admin-disputes');
                this.loaderService.hideLoader();
              }
            }
          }
        },
        {
          text: 'Annulla',
          color: 'default',
          close: true,
          value: false,
          disabled: false,
          callback: () => {
            dialog.close();
          }
        }
      ];
    } else {
      buttons = [
        {
          text: 'Richiedi',
          color: 'default',
          close: true,
          value: true,
          disabled: false,
          callback: async (value) => {
            this.emitData.emit(opt);
            /*this.loaderService.showLoader();
             try {
              await this.studyPlanService.deactivateSubscription(data.id);
              await this.retrieveAllSubscriptionsBySubject();
            } catch (ex) {
              this.utilsService.newWarningSnackbar(`C'e' stato un errore imprevisto, riprovare...`);
            } finally {
              this.loaderService.hideLoader();
            } */
          }
        },
        {
          text: 'Proposta Variazione',
          color: 'default',
          close: false,
          value: false,
          disabled: hideVariationProposalButton,
          hide: hideVariationProposalButton,
          callback: async (value) => {
            this.variationDialog = this.dialog.open(VariationProposalComponent, {
              width: '400px',
              maxHeight: '80vh',
              panelClass: 'custom-panel-class',
              data: {
                richiedente: this.richiedente,
                ricevente: opt.professor,
                disponibilitaRicevente: opt.availability,
                disponibilitaRichiedente: this.studentAvailabilities,
                title: 'Richiedi Variazione',
                color: this.color,
                subtitle: this.subscriptionName + ' - ' + this.subscriptionTypeToShow,
                // obj: value,
                okCallback: async (v) => {
                  // if (this.variationDialog) {
                  //   this.variationDialog.close();
                  // }
                  const obj: any = {
                    professorId: opt.professorId,
                    studentBestMatchId: this.studentBestMatchRequestId,
                    text: v.motivazione,
                    subscriptionId: this.subscriptionId
                  };
                  this.loaderService.showLoader();
                  const resp: any = await this.disputeService.newMultipleVariation(obj).catch((err) => {
                    console.error(err);
                  }).finally(() => {
                    this.loaderService.hideLoader();
                  });
                  if (resp) {
                    if (resp.ok) {
                      this.variationDialog.close();
                      dialog.close();
                      this.router.navigateByUrl('/users-area/student-communications');
                    }
                  }
                },
                nokCallback: () => {
                  if (this.variationDialog) {
                    this.variationDialog.close();
                  }
                }
              },
            });
          }
        },
        {
          text: 'Chiudi',
          color: 'default',
          close: true,
          value: false,
          disabled: false,
          callback: () => {
            dialog.close();
          }
        }
      ];
    }
    const dialog = this.dialog.open(ViewAvailabilitiesComponent, {
      width: '400px',
      maxHeight: '80vh',
      panelClass: 'custom-panel-class',
      data: {
        isChangeProfessorProposal: this.isChangeProfessorProposal,
        title: 'Dettaglio disponibilità',
        color: this.color,
        obj: opt.availability,
        professor: opt.professor,
        disponibilitaRichiedente: this.studentAvailabilities,
        buttons: buttons
      }
    });
    return await dialog.afterClosed().toPromise();
  }

  async openCurriculumPreview(professor) {
    if (professor.curriculumEntityId) {
      this.loaderService.showLoader();
      const curriculum: any = await this.curriculumService.getCurriculumById(professor.curriculumEntityId).catch((err) => {
        this.loaderService.hideLoader();
      });
      if (curriculum) {
        if (curriculum.ok) {
          if (curriculum.payload) {
            this.loaderService.hideLoader();
            const openPreview = this.dialog.open(VievProfessorCurriculumComponent, {
              width: '400px',
              maxHeight: '80vh',
              panelClass: 'custom-panel-class',
              data: {
                professor: professor,
                curriculum: curriculum.payload
              }
            });
          }
        }
      }
    } else {
      this.utilsService.newErrorSnackbar('Il formatore non ha ancora caricato un curriculum', 2000);
    }
  }

}
